<template>
    <div class="bg-gray relative z-0">
        <div class="page-container page-container--left-white">
            <div class="p-0 lg:p-5">
                <h1 class="mb-10 px-5 lg:px-0">
                    Order Consumables
                </h1>

                <div class="grid grid-cols-1 lg:grid-cols-2 order-last" :class="{'items-center': success}">
                    <div class="px-5 lg:p-0 lg:px-20 mb-8 lg:ml-auto lg:mx-0">
                        <div class="style-emph ">
                            Machine Details
                        </div>
                        <equipment-card :equipment="equipment"></equipment-card>
                    </div>
                    <div class="bg-white px-5 py-8 lg:p-0 lg:bg-transparent lg:pr-20 lg:order-first">
                        <div v-if="success">
                            <div class="py-12">
                                <div>
                                    <i class="fas fa-check-circle text-6xl text-success"></i>
                                </div>
                                <div class="text-xl mt-5">
                                    Success!
                                </div>
                                <div class="style-body mt-5">
                                    <p class="mb-2">
                                        Your consumables have been ordered successfully. <br>
                                        <strong class="font-bold">Order Ref. {{ orderNumber }}</strong>
                                    </p>
                                    <div class="mt-8">
                                        <a
                                                @click="$router.go(-1)"
                                                class="text-red hover:text-red-hover font-light underline cursor-pointer">Go Back</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <order-form v-if="equipment" :equipmentID="equipment.id"
                                        @submit-success="onSuccess"></order-form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script charset="utf-8">
    import OrderForm from './form/OrderForm.vue';
    import EquipmentCard from './includes/EquipmentCard.vue';

    export default {
        name: 'ServiceCallDetail',
        props: ['equipment'],
        data() {
            return {
                submitted: false,
                success: false,
                orderNumber: ''
            }
        },

        components: {
            EquipmentCard, OrderForm
        },

        methods: {
            onSuccess(value){
                this.success = true;
                this.orderNumber = value;
            }
        },
    }
</script>
